import React from 'react'
import I18n from 'i18n-js'
// @ts-ignore
import UserService from 'core/services/user_service'
import { UserBoxContent } from './user_box_content'
import styles from './style.module.scss'
import { replaceUrlUtmMedium } from 'carpool_shared/utils/url'

declare let gon: {
  config: {
    navigation: {
      account_path: string
      livemap_path: string
      editor_path: string
      support_path: string
      carpool_web_path: string
      carpool_go_path: string
      report_issue_path: string
    }
  }
}

interface IUserBoxProps {
  userName: string
  riderOnboarded: boolean
  imageUrl?: string
  email?: string
  headerPictureSize?: number
}

export const LogoutMenu: React.FunctionComponent<{}> = () => (
  <div
    className={styles.menuItem}
    onClick={() => {
      new UserService().logout().then(() => location.reload())
    }}
    data-test-id='user-box-logout'
  >
    {I18n.t('application.quick_win_header.logout')}
  </div>
)

export const UserBox: React.FunctionComponent<IUserBoxProps> = ({
  userName,
  riderOnboarded,
  email,
  imageUrl,
  headerPictureSize
}) => {
  const carpool_path = riderOnboarded
    ? gon.config.navigation.carpool_web_path
    : gon.config.navigation.carpool_go_path

  const urls = [
    {
      href: gon.config.navigation.account_path,
      text: I18n.t('application.quick_win_header.account')
    },
    {
      href: gon.config.navigation.livemap_path,
      text: I18n.t('application.quick_win_header.live_map')
    },
    {
      href: replaceUrlUtmMedium(carpool_path, 'website_userbox'),
      text: I18n.t('application.quick_win_header.carpool')
    },
    {
      href: gon.config.navigation.editor_path,
      text: I18n.t('application.quick_win_header.map_editor')
    },
    {
      href: gon.config.navigation.support_path,
      text: I18n.t('application.quick_win_header.support')
    },
    {
      href: gon.config.navigation.report_issue_path,
      text: I18n.t('application.quick_win_header.report_issue')
    }
  ]
  return (
    <UserBoxContent
      userName={userName}
      imageUrl={imageUrl}
      email={email}
      headerPictureSize={headerPictureSize}
    >
      {urls.map(({ href, text }, i) =>
        href ? (
          <a
            key={i}
            className={styles.menuItem}
            href={href}
            target='_blank'
            rel='noopener noreferrer'
          >
            {text}
          </a>
        ) : null
      )}
      <LogoutMenu />
    </UserBoxContent>
  )
}
